import { render } from "./mvt-nearbyplaces.vue?vue&type=template&id=68021178"
import script from "./mvt-nearbyplaces.js?vue&type=script&lang=js"
export * from "./mvt-nearbyplaces.js?vue&type=script&lang=js"

import "./mvt-nearbyplaces.vue?vue&type=style&index=0&id=68021178&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__